export default "__VITE_ASSET__65a7b404__"